export type User = Components.Schemas.User;
export type PhoneNumber = Components.Schemas.PhoneNumber;
export type ExtendedPhoneNumber = PhoneNumber & { onBlurFlag?: boolean }; //! Extending the PhoneNumber schema to include onBlurFlag
export type MfaMethod = Components.Schemas.MfaMethod;
export type UserSecurityAnswer = Components.Schemas.UserSecurityAnswer;
export type CompanyWhitelist = Components.Schemas.CompanyWhitelist;
export type SaveNoteRequestBody = Components.RequestBodies.SaveNoteRequestBody;
export type SaveStatusRequestBody =
	Components.RequestBodies.SaveStatusRequestBody;
export type WhitelistStatus = Components.Schemas.WhitelistStatus;
export type UserWithOptionalErrorMessage = Components.Schemas.User & {
	error?: string;
};

export const emptyUser = (): User => ({
	id: '',
	email: '',
	firstName: '',
	lastName: '',
	phoneNumber: {
		rawPhoneNumber: undefined,
		countryCode: undefined,
	},
	active: false,
	verified: false,
	isWhitelisted: false,
});

export type UpdateUserProfile = {
	firstName?: string;
	lastName?: string;
	email?: string;
	mobilePhoneNumber?: string;
};

export interface UserWithRoleName {
	user: User;
	roleName: string;
	roleId: string;
	roleIsUniversal?: boolean;
	isOracle?: boolean;
	isCompanyAdmin?: boolean;
}
